@if (media) {
  @switch (playerType) {
    @case (playerTypes.INLINE) {
      <mb-inline-player
        [allowPictureInPicture]="allowPictureInPicture"
        [showBackButton]="showBackButton"
        [media]="media"
        [muted]="muted || hoverVideo"
        [hideTitle]="hideTitle"
        [hideBottomTitle]="hideBottomTitle"
        [autoplay]="autoplay"
        [controls]="controls"
        [loop]="loop"
        [hoverVideo]="hoverVideo"
        (capture)="setCapture($event)"
        (backButton)="backButton.emit()"
      ></mb-inline-player>
    }
    @case (playerTypes.SIMPLE) {
      <mb-simple-player
        [media]="media"
        [autoplay]="autoplay"
        [loop]="loop"
        [controls]="controls"
        [hoverVideo]="hoverVideo"
        [playsInline]="playsInline"
      ></mb-simple-player>
    }
  }
}
